import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FloatingButton extends ThemeComponent {

    private observer?: IntersectionObserver;

    init() {
        if (!this) {
            return;
        }

        if (!this.observer) {  // Initialize the observer only once
            this.initializeObserver();
        }
    }

    private initializeObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        this.observer = new IntersectionObserver((entries) => {
            let footerVisible = false;
            for (const entry of entries) {
                if (entry.target.classList.contains('site-footer')) {
                    footerVisible = entry.isIntersecting;
                }
            }

            // Hide floating button when footer is visible
            this.toggleFloatingButton(!footerVisible);

        }, options);

        // Observe the footer
        const footerTarget = document.querySelector('.site-footer');

        if (footerTarget) {
            this.observer.observe(footerTarget);
        }
    }

    private toggleFloatingButton(show: boolean) {
        if (show) {
            this.classList.remove('is-hidden');
            this.classList.add('is-visible');
        } else {
            this.classList.add('is-hidden');
            this.classList.remove('is-visible');
        }
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
